import type { SwitchProps } from 'antd';
import classNames from 'classnames';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';
import { useStore } from 'zustand';

import { inventoryStore } from '../../../../InventoryStore';

import { EditableSwitchField } from './EditableSwitchField';
import styles from './SwitchCell.module.scss';

export type SwitchCellProps = {
  disabled?: boolean;
  className?: string;
  label?: string | number;
  labelPosition?: 'top' | 'bottom';
  name: NamePath;
} & Omit<SwitchProps, 'checked' | 'onChange'>;

export const SwitchCell: React.FC<SwitchCellProps> = React.memo(
  ({
    disabled = false,
    className = '',
    label,
    labelPosition = 'top',
    name,
  }) => {
    const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);

    return (
      <div
        className={classNames(
          styles.switchCell,
          {
            [styles.labelTop]: labelPosition === 'top',
            [styles.labelBottom]: labelPosition === 'bottom',
            [styles.disabled]: disabled,
          },
          className
        )}
      >
        {!isEditMode && label && labelPosition === 'top' && (
          <span className={styles.label}>{label}</span>
        )}
        {isEditMode && (
          <>
            <span className={styles.label}>∞</span>
            <EditableSwitchField name={name} disabled={disabled} />
          </>
        )}
      </div>
    );
  }
);
